'use client';

import { __makeTemplateObject } from '../../../_virtual/_tslib.js';
import React__default, { useMemo } from 'react';
import styled from 'styled-components';
import { LIST_COLORS } from '../../helper/config.js';
import CurveLine from '../icons/CurveLine.js';
import Circle from '../icons/Circle.js';
import { colors } from '../../../Utils/constants.js';

var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: ", ";\n    justify-content: ", ";\n    margin-top: 8px;\n    flex-wrap: wrap;\n    flex-direction: ", ";\n"], ["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: ", ";\n    justify-content: ", ";\n    margin-top: 8px;\n    flex-wrap: wrap;\n    flex-direction: ", ";\n"])), function (_a) {
    var align = _a.align;
    return align;
}, function (_a) {
    var justify = _a.justify;
    return justify;
}, function (_a) {
    var direction = _a.direction;
    return direction;
});
var Item = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 4px;\n    font-size: 12px;\n    font-weight: ", ";\n    margin-bottom: 4px;\n    color: ", ";\n    user-select: none;\n    & > .icon {\n        margin-right: 8px;\n    }\n    &:not(:last-of-type) {\n        margin-right: 24px;\n    }\n"], ["\n    display: grid;\n    grid-template-columns: auto 1fr;\n    column-gap: 4px;\n    font-size: 12px;\n    font-weight: ", ";\n    margin-bottom: 4px;\n    color: ", ";\n    user-select: none;\n    & > .icon {\n        margin-right: 8px;\n    }\n    &:not(:last-of-type) {\n        margin-right: 24px;\n    }\n"])), function (_a) {
    var weight = _a.weight;
    return weight;
}, function (_a) {
    var color = _a.color;
    return color;
});
var IconWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: ", ";\n    padding: ", ";\n"], ["\n    display: flex;\n    align-items: ", ";\n    padding: ", ";\n"])), function (_a) {
    var iconAlign = _a.iconAlign;
    return iconAlign;
}, function (_a) {
    var padding = _a.padding;
    return padding;
});
var Legend = function (_a) {
    var config = _a.config;
    var _b = config.chart, data = _b.data, series = _b.series, xField = _b.xField, legend = _b.legend;
    var _c = (config.default || {}).listColors, listColors = _c === void 0 ? LIST_COLORS : _c;
    var _d = legend || {}, line = _d.line, text = _d.text, _e = _d.align, align = _e === void 0 ? 'center' : _e, _f = _d.justify, justify = _f === void 0 ? 'center' : _f, _g = _d.direction, direction = _g === void 0 ? 'row' : _g, icons = _d.icons, decorationValue = _d.decorationValue;
    var _h = icons || {}, _j = _h.align, iconAlign = _j === void 0 ? 'center' : _j, _k = _h.padding, padding = _k === void 0 ? '' : _k;
    var _l = text || {}, _m = _l.color, color = _m === void 0 ? colors.textColor : _m, _o = _l.weight, weight = _o === void 0 ? 700 : _o;
    var legendData = useMemo(function () {
        var result = [];
        data.forEach(function (item) {
            if (series) {
                if (!result.includes(item[series])) {
                    result.push(item[series]);
                    return;
                }
                return;
            }
            if (!result.includes(item[xField])) {
                result.push(item[xField]);
            }
        });
        return result;
    }, [series, xField, data]);
    return (React__default.createElement(List, { align: align, direction: direction, justify: justify }, legendData.map(function (item, index) {
        return (React__default.createElement(Item, { key: "".concat(item, "-").concat(index), color: color, weight: weight },
            React__default.createElement(IconWrapper, { iconAlign: iconAlign, padding: padding }, line ? (React__default.createElement(CurveLine, { className: 'icon', color: listColors[index].foreground })) : (React__default.createElement(Circle, { className: 'icon', color: listColors[index].foreground }))),
            decorationValue ? decorationValue(data[index]) : item));
    })));
};
var templateObject_1, templateObject_2, templateObject_3;

export { Legend as default };
//# sourceMappingURL=legend.rc.js.map
